import { render, staticRenderFns } from "./travelCateAd.vue?vue&type=template&id=50bf2234&scoped=true&"
import script from "./travelCateAd.vue?vue&type=script&lang=js&"
export * from "./travelCateAd.vue?vue&type=script&lang=js&"
import style0 from "./travelCateAd.vue?vue&type=style&index=0&id=50bf2234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf2234",
  null
  
)

export default component.exports